import { render } from "./ItemInfoComponent.vue?vue&type=template&id=9c09d972&scoped=true&ts=true"
import script from "./ItemInfoComponent.vue?vue&type=script&lang=ts"
export * from "./ItemInfoComponent.vue?vue&type=script&lang=ts"

import "./ItemInfoComponent.vue?vue&type=style&index=0&id=9c09d972&lang=sass&scoped=true"
/* custom blocks */
import block0 from "./ItemInfoComponent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c09d972"]])

export default __exports__